import ChildMenu from "./ChildMenu";
import GrandChildrenMenu from "./GrandChildrenMenu";

const ChildMenuItemList = ({
  item,
  showModalsHandler,
  closeModalsHandler,
  childDrop1IsOpen,
  childDrop2IsOpen,
  modalHrefHandler,
  modalTitle,
  closeChildMenuHandler,
  modalContents,
  ModalContentList,
}) => {
  return item.children.map((childItem, index) => {
    let hasGrandChildren = childItem.classes.find(item => item === "hasGrand");
    if (childItem.menu_item_parent !== 0 && hasGrandChildren) {
      return (
        <GrandChildrenMenu
          key={childItem.ID}
          childItem={childItem}
          index={index}
          closeModalsHandler={closeModalsHandler}
          showModalsHandler={showModalsHandler}
          childDrop1IsOpen={childDrop1IsOpen}
          childDrop2IsOpen={childDrop2IsOpen}
          modalHrefHandler={modalHrefHandler}
          modalTitle={modalTitle}
          closeChildMenuHandler={closeChildMenuHandler}
          modalContents={modalContents}
          ModalContentList={ModalContentList}
        />
      );
    } else {
      return (
        <ChildMenu
          key={childItem.ID}
          childItem={childItem}
          closeChildMenuHandler={closeChildMenuHandler}
        />
      );
    }
  });
};

export default ChildMenuItemList;
